import { Box, Typography, Button } from "@mui/material";
import { DesignerFileTypeSelection } from "./designer-file-type-selection";
import { DesignerFileType } from "../../../__generated__/types";
import { Pages } from "../../../utils";
import { useNavigate } from "react-router";
import DashboardHeader from "../../../components/dashboard-header";
import { useUserContext } from "../../../hooks/userContext";
import { useDesignerOnboardingAccess } from "../../../hooks/useDesignerOnboardingAccess";

const routes = {
  [DesignerFileType.DesignBoard]: Pages.ADD_DESIGNER_FILE__BOARD,
  [DesignerFileType.BeforeAndAfter]: Pages.ADD_DESIGNER_FILE__BEFORE_AFTER,
  [DesignerFileType.ProjectProfile]: Pages.ADD_DESIGNER_FILE__PROJECT_PROFILE,
};

export const SelectDesignerFileTypeView = () => {
  const navigate = useNavigate();
  const { user } = useUserContext();
  const { isDesignerFilesUnlocked } = useDesignerOnboardingAccess();

  // Show message if designer files is locked instead of redirecting
  if (user?.accountType === 'Designer' && !isDesignerFilesUnlocked) {
    return (
      <Box
        sx={{
          backgroundColor: "#F5F5F5",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "16px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            p: 4,
            maxWidth: "500px",
            textAlign: "center",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
            Complete Your Bio First
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary", mb: 3 }}>
            You need to complete your Designer Bio before you can add Designer Files.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate(Pages.MY_BIO)}
            sx={{ backgroundColor: "#00A06D" }}
          >
            Go to My Bio
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        backgroundColor: "#F5F5F5",
        minHeight: "100vh",
      }}
    >
      <DashboardHeader 
        title="Choose a Design File Type to Get Started"
        showBackButton={true}
      />

      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 3, // 12px - standardized
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.06)", // standardized shadow
          p: 4,
          mx: 0, // Remove horizontal margin to align with header
        }}
      >
        <DesignerFileTypeSelection onSelect={(type) => navigate(routes[type])} />
      </Box>
    </Box>
  );
};
